import { render, staticRenderFns } from "./FlashCardBook.vue?vue&type=template&id=798fb289&"
import script from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardBook.js?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardBook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports